import { render } from "./FormInput.vue?vue&type=template&id=248ea94f&scoped=true&ts=true"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=248ea94f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248ea94f"]])

export default __exports__